import ApiService from "./api.service";
export default class CategoryService extends ApiService {
    static base_url = `${super.base_url}/categories`;
}
